import React from 'react';
import { Link } from 'react-router-dom';
import { GameSession } from '../../types';
import Button from '../ui/Button';
import { useAdventureStyle } from '../../hooks/useAdventureStyle';

export interface ActiveAdventureCardProps {
  session: GameSession;
  characterName?: string | undefined;
  currentSceneDescription?: string | undefined;
  playerId?: string | undefined;
}

const ActiveAdventureCard: React.FC<ActiveAdventureCardProps> = ({
  session,
  characterName,
  currentSceneDescription,
  playerId
  }) => {
  const adventureTitle = session.adventure?.title || 'Unknown Adventure';
  const { buttonColor } = useAdventureStyle();
  
  // Remove unused variable warning
  void currentSceneDescription;

  return (
    <div
      data-testid="active-adventure-card"
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        borderRadius: '0.75rem',
        padding: '1.25rem',
        marginBottom: '1rem',
        transition: 'all 0.3s ease-in-out',
        backdropFilter: 'blur(12px)',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.2), 0 2px 4px -1px rgba(0, 0, 0, 0.1)',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale'
      }}
      className="hover:shadow-lg hover:border-white/30 hover:bg-black/40 hover:-translate-y-1"
    >
      <div className="flex flex-col space-y-3">
        {/* Adventure and Character Info */}
        <div>
          <h3 
            className="text-lg font-semibold"
            style={{ color: '#ffffff' }}
          >
            {adventureTitle}
          </h3>
          {characterName && (
            <p 
              className="text-sm font-medium"
              style={{ color: '#e5e7eb' }}
            >
              Playing as: <span style={{ color: '#c7d2fe', fontWeight: '600' }}>{characterName}</span>
            </p>
          )}
        </div>
        
        {/* Action Button */}
        <Link to={`/scene/${session.id}/${playerId || 'unknown'}`}>
          <Button 
            variant="glass-primary" 
            size="md" 
            fullWidth
            className="transition-all duration-200 hover:scale-105"
            data-testid="continue-adventure-button"
            customColor={buttonColor}
          >
            🎮 Continue Adventure
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default ActiveAdventureCard;
